function msg(msg) {
	this.$message({
		message: '请重新登录',
		showClose: true,
		type: 'error'
	});
}

export default msg